import { USERTYPES } from 'components/Common/Constant';
import { useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';

const EditModal = ({ modal, setModal, handleSubmit, setAddUserData, addUserData, isModifying }) => {

    const toggle = () => setModal(!modal)

    const handleInputChange = async (e) => {
        try {
            setAddUserData((pre) => ({
                ...pre,
                [e.target.name]: e.target.value
            }))
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Enter the details</ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <FormGroup>
                        <Label for="firstname">First name</Label>
                        <Input
                            type="text"
                            name="firstname"
                            id="firstname"
                            placeholder="Enter firstname"
                            value={addUserData?.firstname || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="lastname">Last name</Label>
                        <Input
                            type="text"
                            name="lastname"
                            id="lastname"
                            placeholder="Enter lastname"
                            value={addUserData?.lastname || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter email"
                            value={addUserData?.email || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    {/* <FormGroup>
                        <Label for="phone">Phone Number</Label>
                        <Input
                            type="number"
                            name="phoneNumber"
                            id="phone"
                            placeholder="Enter phone number"
                            value={addUserData?.phoneNumber || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup> */}
                    <FormGroup>
                        <Label for="phone">Password</Label>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Enter password"
                            value={addUserData?.password || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={isModifying} color="primary" type="submit">Submit</Button>{' '}
                    <Button disabled={isModifying} color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}

export default EditModal